<template src="./pinboard-comment.html"></template>

<script lang="ts">
import formatName from 'filters/format-name'
import { getElapsedTime } from 'util/time-utils'
import { truncateText } from 'util/text-utils'


export default {
  data() {
    return {
      isTextTruncated: false
    }
  },
  props: {
    comment: {
      type: Object,
      required: true
    },
    commentMaxLength: {
      type: Number,
      required: true
    },
    // hard-coded as it is in 4.3.  May make a config option as we have for other widgets
    truncateAllowance: {
      type: Number,
      default: 9
    },
    userNameMaxLength: {
      type: Number,
      required: true
    }
  },
  emits: ['expanded'],
  computed: {
    commentText() {
      return this.isTextTruncated ? this.truncatedText : this.comment.text
    },
    elapsedTime() {
      return getElapsedTime(this.comment.dateCreatedMillis)
    },
    formattedName() {
      return formatName(this.comment.user)
    },
    isUserNameTruncated() {
      return this.formattedName.length > this.userNameMaxLength
    },
    truncatedText() {
      const text = this.comment.text.trim()
      return truncateText(text, this.commentMaxLength, this.truncateAllowance)
    },
    author() {
      return this.isUserNameTruncated ?
        this.formattedName.substring(0, this.userNameMaxLength) : this.formattedName
    }
  },
  methods: {
    expandComment() {
      this.isTextTruncated = false
      // notify the pinboard item that a comment is expanding. This eventually bubbles up
      // to the Masonry Layout (layout.ts) to adjust the other pins to make room.
      this.$emit('expanded', this)
    }
  },
  created() {
    if (this.truncatedText) {
      this.isTextTruncated = true
    }
  }
}
</script>

<style lang="scss" src="./pinboard-comment.scss"></style>
